import React, { Component } from 'react';
import PropTypes from 'prop-types';
import lodashCompact from 'lodash/fp/compact';

import {
  defaultApartmentLocator,
} from 'common/apartmentLocatorHelpers';
import analytics from 'client/analytics';
import {
  ANALYTICS_EVENT_APARTMENT_LOCATOR_CONTACT_BUTTON_CLICK,
} from 'client/analytics/eventList';
import Navbar from 'client/components/Navbar';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withScreenId from 'client/helpers/withScreenId';
import ListingActions from 'client/actions/Listing';
import UserActions from 'client/actions/User';
import NavigatorActions from 'client/actions/Navigator';

import branch from 'client/core/branch';
import SrListingApartmentLocatorSection from 'client/components/SrListingApartmentLocatorSection';
import { SCREEN_ID_LISTING_APARTMENT_LOCATOR } from 'client/constants/screenIds';

@withTransitionHook
@withScreenId(SCREEN_ID_LISTING_APARTMENT_LOCATOR)
@withScrollToTop
@branch({
  listing: ['listing'],
  assignedApartmentLocator: ['assignedApartmentLocator'],
  appUrl: ['env', 'APP_URL'],
})
class ListingApartmentLocator extends Component {
  static fetchData(match, inject) {
    const currentUserId = inject.state.get(['currentUser', 'id']);

    return Promise.all(lodashCompact([
      ListingActions.getById(inject, parseInt(match.params.listingId, 10)),
      currentUserId && UserActions.getApartmentLocator(inject, currentUserId),
    ]));
  }

  static getPageMetadata = () => ({
    pageTitle: 'Sunroom Rentals | Apartment Locator',
    section: 'Apartment Locator',
  })

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    assignedApartmentLocator: PropTypes.object,
    listing: PropTypes.object,
    appUrl: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(NavigatorActions.clearPathHistory);
  }

  _onContactApartmentLocatorClick = () => {
    const {
      dispatch,
      listing,
    } = this.props;

    analytics.track(ANALYTICS_EVENT_APARTMENT_LOCATOR_CONTACT_BUTTON_CLICK);

    dispatch(ListingActions.contactApartmentLocatorButtonClick, {
      listingId: listing.id,
    });
  };

  render() {
    const { assignedApartmentLocator, listing, appUrl, history } = this.props;
    const apartmentLocator = assignedApartmentLocator || defaultApartmentLocator;
    const isDefault = apartmentLocator === defaultApartmentLocator;

    return (
      <div className='page-apartmentLocator'>
        <Navbar disableRedirect />
        <SrListingApartmentLocatorSection
          apartmentLocator={apartmentLocator}
          onContactApartmentLocatorClick={this._onContactApartmentLocatorClick}
          listing={listing}
          appUrl={appUrl}
          isDefault={isDefault}
          history={history}
        />
      </div>
    );
  }
}

ListingApartmentLocator.displayName = 'ListingApartmentLocator';

export default ListingApartmentLocator;
